import { NumberFormatter, Table } from '@mantine/core'
import { Collapse } from '@shared/components/collapse/collapse'
import { formatDate } from '@shared/helpers/format-date/format-date'
import { UnprocessedLotModel } from '@shared/loom-api/.generated/types'
import { useState } from 'react'
import classes from '@/components/speci/speci-sidebar-table.module.css'

type UnprocessedWoolOnHoldTableProps = {
  heading?: string
  data: UnprocessedLotModel[]
}

export const UnprocessedWoolOnHoldTable = ({
  heading = 'Unprocessed Wool On Hold',
  data = [],
}: UnprocessedWoolOnHoldTableProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const rows = data.map((unprocessedLot) => (
    <Table.Tr key={unprocessedLot.internalReferenceCode}>
      <Table.Td>{unprocessedLot.internalReferenceCode}</Table.Td>
      <Table.Td>{unprocessedLot.saleNumber}</Table.Td>
      <Table.Td>{unprocessedLot.purchaseDescription}</Table.Td>
      <Table.Td ta='right'>{unprocessedLot.totalBales}</Table.Td>
      <Table.Td ta='right'>
        <NumberFormatter value={unprocessedLot.netKg} thousandSeparator />
      </Table.Td>
      <Table.Td>{unprocessedLot.lineNumber}</Table.Td>
      <Table.Td>{formatDate(unprocessedLot.commissionPaymentDate, 'DD/MM/YYYY')}</Table.Td>
    </Table.Tr>
  ))

  return (
    <Collapse
      sectionHeading={heading}
      buttonLabel='table'
      isOpen={isOpen}
      toggle={() => setIsOpen(!isOpen)}
    >
      <Table.ScrollContainer minWidth={600}>
        <div className={classes.tableContainer}>
          <Table withColumnBorders>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Reference</Table.Th>
                <Table.Th>Sale</Table.Th>
                <Table.Th>Description</Table.Th>
                <Table.Th ta='right'>Bales</Table.Th>
                <Table.Th ta='right'>KG</Table.Th>
                <Table.Th>Line Number</Table.Th>
                <Table.Th>Date Added</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>{rows}</Table.Tbody>
          </Table>
        </div>
      </Table.ScrollContainer>
    </Collapse>
  )
}
